import { render, staticRenderFns } from "./PageAndSectionEditor.vue?vue&type=template&id=7bd63537&scoped=true&"
import script from "./PageAndSectionEditor.vue?vue&type=script&lang=js&"
export * from "./PageAndSectionEditor.vue?vue&type=script&lang=js&"
import style0 from "./PageAndSectionEditor.vue?vue&type=style&index=0&id=7bd63537&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd63537",
  null
  
)

export default component.exports